import { createFileRoute } from "@tanstack/react-router";
import AddictionTreatmentVoorheesNJ from "@/pages/AddictionTreatmentVoorheesNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/addiction-treatment-voorhees-nj")({
  head: () => routeHead("/addiction-treatment-voorhees-nj"),
  component: AddictionTreatmentVoorheesNJ,
});
